// removed by extract-text-webpack-plugin
module.exports = {"whitepaper-headline":"index-module__whitepaper-headline___2Ijq3","whitepaperHeadline":"index-module__whitepaper-headline___2Ijq3"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/company/white-paper/index.module.scss
// module id = 1719
// module chunks = 146